import { BsEmojiSmileFill } from "react-icons/bs";
import { useState } from "react";

import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data'

export default function EmpjiPicker({ content, setContent }) {
  const [isPickerVisible, setIsPickerVisible] = useState(false)

  return (
    <div className='d-flex position-relative items-align-center'>
      <BsEmojiSmileFill
			  onClick={() => setIsPickerVisible(true)}
			  className='text-fresh rfs-4 my-auto mx-1 cursor-pointer'
			/>

			<div className={`position-absolute top-100 z-3 translate-middle-x ${isPickerVisible ? 'd-block' : 'd-none'}`}>
			  <Picker data={data} previewPosition="none"
			  	onClickOutside={() => {
				    if (isPickerVisible) setIsPickerVisible(false)
				  }}
				  onEmojiSelect={(e) => {
				    setContent(content + e.native)
				    setIsPickerVisible(!isPickerVisible)
				  }}
			  />
			</div>
    </div>
  )
}
